import React from 'react';
import tiaAvatar from './img/tia-avatar.png';
import { DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideMatterDialog({ onSubmit }) {
  const playful = usePlayfulStudent();

  return (
    <DialogContent>
      <div className="flex flex-wrap items-start gap-4 text-left">
        <AvatarWrapper
          size="md"
          src={tiaAvatar}
          text="T.I.A"
          title="T.I.A"
        />

        <div className="w-[200px] max-w-full grow">
          <DialogHeader>
            <DialogTitle className="text-sm font-bold text-primary">Você tem certeza?</DialogTitle>
          </DialogHeader>

          <DialogDescription>Se fizer isso, ela será removida do seu guia de estudos e só voltará quando você desbloquear.</DialogDescription>

          <DialogFooter className="gap-3 sm:justify-start">
            <Button
              wide
              onClick={onSubmit}
              style={playful ? { background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)', border: 'none' } : undefined}
            >
              Sim
            </Button>

            <DialogClose asChild>
              <Button
                variant="outline-danger"
                wide
              >
                Não
              </Button>
            </DialogClose>
          </DialogFooter>
        </div>
      </div>
    </DialogContent>
  );
}
